import {$http} from './axiosHttp';//引入axios

export const getDataNewsTop = p => $http.post(`${serverUrl}${baseUrl}/news/top`, p);
export const getDataNews = p => $http.post(`${serverUrl}${baseUrl}/news/getList`, p);
export const getNewsInfo = p => $http.post(`${serverUrl}${baseUrl}/news/detail`, p);
export const getLogin = p => $http.post(`${serverUrl}${baseUrl}/login/signIn`, p);
export const getAutoLogin = p => $http.post(`${serverUrl}${baseUrl}login/isAutoLogin`, p);
// export const getCaseList = p => $http.post(`${serverUrl}${baseUrl}/practice/getList`, p);
export const getCaseListInfo = p => $http.post(`${serverUrl}${baseUrl}/practice/detail`, p);
export const getCaseHotList = p => $http.post(`${serverUrl}${baseUrl}/practice/top`, p);
// 意向咨询
export const getCreateInquiry = p => $http.post(`${serverUrl}${baseUrl}/inquiry/createInquiry`, p);


/*地图数据*/

export const getPanelData = p => $http.get(`${evaluUrl}${baseUrl}/region/evalCompany`, p);
export const getChartsData = p => $http.get(`${evaluUrl}${baseUrl}/region/countCompany`, p);
export const getmapData = p => $http.all(p);
/**字典 */
export const getDictData = p => $http.get(`${serverUrl}${baseUrl}/front/dict/data/type/${p}`);
/**案例 */
export const getCaseList = p => $http.get(`${serverUrl}${baseUrl}/front/case/list`, p);
export const getCaseDetail = p => $http.get(`${serverUrl}${baseUrl}/front/case/${p}`);
/**新闻 */
export const getNewsList = p => $http.get(`${serverUrl}${baseUrl}/front/news/list`, p);
export const getNewsDetail = p => $http.get(`${serverUrl}${baseUrl}/front/news/${p}`);
/**首页 成功案例 */
export const getCaseListTop = () => $http.get(`${serverUrl}${baseUrl}/front/case/listTop`);
export const getCustomer = p => $http.get(`${serverUrl}${baseUrl}/front/customer/add`, p);
/** 专家入驻 */
export const getExpert = p => $http.post(`${serverUrl}${baseUrl}/front/customer/addExpert`, p);




// WEBPACK FOOTER //
// ./src/request/api.js